/** The small brand bullet that separates inline metadata (date • time • level). */
export default function Dot() {
  return <span className="h-1 w-1 shrink-0 rounded-full bg-color-brand-primary" />;
}
